import React, { useEffect } from "react";

import TextFieldWrapper from "./textFieldWrapper";
import { openPopUp } from "../popUp";
import ValueDragPopUp from "../valueDragPopUp";

interface TextFieldDropdownProps {
    label: string;
    suffix?: string;
    title: string;
    className?: string;
    options: string[];
    active: string;
    setActive: (v: string) => void;
    border?: boolean;
}

export default function TextFieldDropdown(props: TextFieldDropdownProps) {
    return <TextFieldWrapper border={props.border} className={props.className} label={props.label}>
        <div className="dropdown grey-box" onClick={() => {
            openPopUp(<ValueDragPopUp setActive={props.setActive} options={props.options} defaultActive={props.active} title={props.title}/>);
        }}>
            <span>{props.active}</span>
        </div>
        {props.suffix && <a>{props.suffix}</a>}
    </TextFieldWrapper>;
}